//@flow
import * as React from 'react';
import { Card, Column, Stack } from '@locus-taxy/neo-ui';
import LoginFragment from './LoginFragment';

const LoginRightSection = () => {
    return (
        <Column width="1/3">
            <Stack as="form">
                <Card>
                    <LoginFragment />
                </Card>
            </Stack>
        </Column>
    );
};

export default LoginRightSection;
